import { useParams, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useUser } from '../context/useUser';
import UserForm from '../components/UserForm/UserForm';
import { FormContainer } from '../components/UserForm/FormContainer';
import { FormHeader } from '../components/UserForm/FormHeader';
import { LoadingSpinner } from '../components/UserForm/LoadingSpinner';
import { ErrorSnackbar } from '../components/UserForm/ErrorSnackbar';
import { initialValues } from '../constants/userConstants';
import {  userValidationSchema } from '../validations/userValidationSchema';
import { useTenant } from '../../../shared/context/TenantContext';


export default function UserFormPage() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const { selectedTenant } = useTenant();
  const {
    userData,
    isDataLoading,
    createUser,
    updateUser,
    isSubmitting,
    error,
    setError
  } = useUser();

  function maskCpf(value: string) {
    if (!value) return '';
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
    if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
    return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
  }

  // Função para processar os dados do usuário para o formato do formulário
  const processUserDataForForm = (userData: any) => {
    if (!userData) return {
      name: '',
      email: '',
      cpf_or_rg: '',
      phone: '',
      birth_date: '',
      role: 'organizer', 
      password: '',
    };

    return {
      name: userData.name || '',
      email: userData.email || '',
      cpf_or_rg: maskCpf(userData.cpf_or_rg || ''),
      phone: userData.phone || '',
      birth_date: userData.birth_date || '',
      role: userData.role || 'organizer', // Força organizador se não vier
      password: '',
    };
  };

  async function handleSubmit(formData: any) {
    try {
      const dataToSend = {
        ...formData,
        cpf_or_rg: formData.cpf_or_rg.replace(/\D/g, ''),
        birth_date: formData.birth_date || new Date().toISOString().slice(0, 10),
     
      };

      if (isEdit && id) {
        delete dataToSend.password;
        await updateUser(id, dataToSend);
        navigate(`/users/${id}`);
      } else {
        await createUser(dataToSend);
        navigate('/users');
      }
    } catch (error) {
      console.error('Erro ao salvar usuário:', error);
    }
  }
  function handleCancel() {
    navigate(-1);
  }

  if (isEdit && isDataLoading) {
    return (
      <FormContainer>
        <LoadingSpinner />
      </FormContainer>
    );
  }

  const formInitialValues = isEdit && userData 
    ? processUserDataForForm(userData)
    : { ...initialValues, role: 'organizer' }; 





  return (
    <>
      <ErrorSnackbar 
        error={error} 
        onClose={() => setError(null)} 
      />
      
      <FormContainer>
        <FormHeader mode={isEdit ? 'edit' : 'create'} />
        
        <Formik
          initialValues={formInitialValues}
          validationSchema={userValidationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isValid, dirty, values, errors }) => {
            console.log('Formik - values:', errors);
            return (
              <Form>
                <UserForm
                  mode={isEdit ? 'edit' : 'create'}
                  loading={isSubmitting}
                  onCancel={handleCancel}
                  userId={id}
                />
              </Form>
            );
          }}
        </Formik>
      </FormContainer>
    </>
  );
}